import React from 'react';
import { useSelector } from 'react-redux';
import { getRMDReductionAmount } from '../../../redux/modules/qcd/qcd.selectors';
import { currency } from '../../../utils/utils';
import { SSJBeaconButton } from '../../Shared/Beacon/Registry';

import './ReduceAutoRMD.scss';

const ReduceAutoRMD = ({ closeReduceAutoRMD }) => {
  const totalGrossAmount = useSelector(getRMDReductionAmount);
  return (
    <div className="reduce-auto-rmd-container">
      <h1 className="reduce-auto-rmd-heading">
        Reduce my existing RMD program
      </h1>
      <div className="reduce-auto-rmd-text">
        Please update my RMD program to reduce the distribution by{' '}
        {currency(totalGrossAmount)}. This amount includes QCD requests from
        Traditional and Rollover IRAs only. I understand that it will reduce my
        IRA systematic withdrawals proportionately from each mutual fund within
        the type of IRA from which it was distributed.{' '}
      </div>
      <div className="reduce-auto-rmd-text">
        Please note, this option only applies to an existing systematic
        withdrawal program in which T. Rowe Price is calculating the
        distribution based on a life expectancy. To allow time for processing,
        please submit this transaction at least 5 days in advance of your next
        payment date. Failure to do so may prevent your systematic RMD from
        being updated timely. This may result in more money being distributed
        than is necessary to satisfy your RMD.
      </div>

      <div className="close-button-container">
        <SSJBeaconButton
          id="close-button"
          className="close-button"
          label="OK"
          variant="primary"
          disabled={false}
          onClick={closeReduceAutoRMD}
        />
      </div>
    </div>
  );
};

export default ReduceAutoRMD;
